<template>
  <div class="buy">
    <app-header />
    <div class="container">
      <div class="box-btn">
        <div class="float-right">
          <button type="button" v-b-modal.modalFilters class="btn btn-primary">
            Filtrar
          </button>
        </div>
        <div class="d-inline">
          <button type="button" v-on:click="generateCVS()" class="btn btn-primary">
            CSV
          </button>
        </div>
      </div>
      <div class="table table-padded">
        <b-card mb-2>
          <b-row>
            <b-col md="6" class="my-1">
              <b-form-group horizontal label="Buscador" class="mb-0">
                <b-input-group>
                  <b-form-input v-model="filter" />
                  <b-input-group-append>
                    <b-btn :disabled="!filter" @click="filter = ''">Limpiar</b-btn>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6" class="my-1">
              <b-form-group horizontal label="Por página" class="mb-0">
                <b-form-select :options="pageOptions" v-model="perPage" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-table :items="resumen" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" @filtered="onFiltered" class="table table-padded">
            <template slot="id" slot-scope="row">
              {{row.item.id}}
            </template>
            <template slot="type" slot-scope="row">
              <template v-if="row.item.type == 'buy'">
                Compra
              </template>
              <template v-else>
                Consignacion
              </template>
            </template>
            <template slot="date" slot-scope="row">
              {{row.item.updatedAt.substr(0, 10)}}
            </template>
            <template slot="time" slot-scope="row">
              {{row.item.updatedAt.substr(11, 5)}}
            </template>
            <template slot="prevBalance" slot-scope="row">
              ${{money(row.item.prevBalance)}}
            </template>
            <template slot="amount" slot-scope="row">
              <template v-if='row.item.type == "buy"'>
                <h2 class="itemIndicator" :class="row.item.type == 'buy' ? 'low' : '' ">${{money(row.item.amount)}}</h2>
              </template>
              <template v-else>
                <h2 class="itemIndicator">${{money(row.item.relAmount)}}</h2>
              </template>
            </template>
            <template slot="newBalance" slot-scope="row">
              ${{money(row.item.newBalance)}}
            </template>
            <template slot="company" slot-scope="row">
              {{row.item.Company.name}}
            </template>
          </b-table>
          <b-row>
            <b-col md="12" class="my-1 float-right">
              <b-pagination :total-rows="resumen.length" :per-page="perPage" v-model="currentPage" class="my-0" />
            </b-col>
          </b-row>
        </b-card>
      </div>
    </div>

    <app-footer />


    <b-modal id="modalFilters" ref="modalFilters" title="Filtrar" hide-footer>
      <form v-on:submit.prevent="read">
        <div class="form-group">
          <label>Fecha inicio</label>
          <input type="date" class="form-control" v-model="filters.dateStart">
        </div>
        <div class="form-group">
          <label>Fecha final</label>
          <input type="date" class="form-control" v-model="filters.dateEnd">
        </div>
        <template >
          <div class="form-group" v-can="'administration.resumen'">
            <label>Empresa</label>
            <select class="form-control" name="bankId" v-model='filters.companyId'>
              <option>Seleccione una empresa</option>
              <option v-for="(company, index) in companies" :key="index" :value="company.id">{{company.name}}</option>
            </select>
          </div>
        </template>
        <div class="d-inline">
          <button type="submit" class="btn btn-primary">Filtrar</button>
        </div>
      </form>
    </b-modal>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { FETCH_RESUMEN, FETCH_COMPANIES } from "@/store/actions.type";

import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import AppPagination from "@/components/AppPagination.vue";

export default {
  components: {
    AppHeader,
    AppFooter,
    AppPagination
  },
  data: function() {
    return {
      filters: {
        dateStart: this.formatDate(Date.now()),
        dateEnd: this.formatDate(Date.now())
      },
      data: {},
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, 20, 30, 40, 50],
      filter: null,
      fields: [
        { key: "id", label: "Id", sorteable: true },
        { key: "type", label: "Tipo", sorteable: true },
        { key: "date", label: "Fecha", sorteable: true },
        { key: "time", label: "Hora", sorteable: true },
        { key: "prevBalance", label: "Saldo anterior", sorteable: true },
        { key: "amount", label: "Valor", sorteable: true },
        { key: "newBalance", label: "Saldo nuevo", sorteable: true },
        { key: "company", label: "Empresa", sorteable: true }
      ]
    };
  },

  mounted() {
    this.read();
  },
  methods: {
    read() {
      this.$refs.modalFilters.hide();
      this.$store.dispatch(FETCH_RESUMEN, this.filters);
      this.$store.dispatch(FETCH_COMPANIES);
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    generateCVS() {
      var rows = this.resumen.map(item => {
        var status = "";
        if (item.type == "buy") {
          status = "Compra";
        } else {
          status = "Consignación";
        }

        return [
          item.id,
          status,
          item.updatedAt.substr(0, 10),
          item.updatedAt.substr(11, 5),
          "$" + Math.round(item.prevBalance),
          "$" + item.relAmount,
          "$" + Math.round(item.newBalance),
          item.Company.name
        ];
      });

      rows = [
        [
          "Id",
          "Tipo",
          "Fecha",
          "Hora",
          "Saldo Anterior",
          "Valor",
          "Saldo nuevo",
          "Empresa"
        ],
        ...rows,
        ["", "", "", "", "", "", "", ""]
      ];

      let csvContent = "";
      rows.forEach(function(rowArray) {
        rowArray = rowArray.map(c => `"${c}"`);
        let row = rowArray.join(";");
        csvContent += row + "\r\n";
      });
      var hiddenElement = document.createElement("a");
      hiddenElement.href =
        "data:text/csv;charset=utf-8," + encodeURI(csvContent);
      hiddenElement.target = "_blank";
      hiddenElement.download = "Extracto.csv";
      hiddenElement.click();
    }
  },

  computed: {
    ...mapGetters(["resumen", "companies"])
  }
};
</script>

<style lang="scss">
.buy {
  label {
    color: #7b7b7b;
    font-weight: 900;
    font-size: 18px;
  }

  select {
    -webkit-appearance: none;
  }

  .box-modal {
    h5 {
      color: #dab51b !important;
      font-weight: 900;
      font-size: 25px;
    }
  }

  .table-head {
    background: #dab51b;
    border: none;
    color: white;
  }
}
</style>
